$ = jQuery;
$(function () {
  $('[data-toggle="agro-menu-toggle"]').on('click', function () {
    $(this).toggleClass('opened');
    $(document.body).toggleClass('menu-opened');
    $($(this).attr('data-target')).toggleClass('opened');
  });

  $('[data-toggle="agro-sidebar-toggle"]').on('click', function () {
    // $(this).toggleClass('opened');
    $(document.body).toggleClass('sidebar-opened');
    $($(this).attr('data-target')).toggleClass('opened');
    hideProductSubmenu($('.sidebar'));
  });

  $('.has-subsubmenu').on('click', function () {
    let subsubmenu = $('.subsubmenu', this);
    if (subsubmenu.hasClass('show')) {
      hideProductSubmenu(this);
    } else {
      showProductSubmenu(this);
    }
  });

  $('.sidebar').on('mouseleave', function () {
    hideProductSubmenu(this);
  });

  function hideProductSubmenuAfterResize() {
    hideProductSubmenu($('.sidebar'))
  }

  function hideProductSubmenu(container) {
    let subsubmenu = $('.subsubmenu', container);
    let arrow = $('.ico-arrow-right-menu', container);
    subsubmenu.removeClass('show');
    subsubmenu.addClass('hidden');
    arrow.addClass('down');
    arrow.removeClass('up');
  }

  function showProductSubmenu(container) {
    let subsubmenu = $('.subsubmenu', container);
    let arrow = $('.ico-arrow-right-menu', container);
    subsubmenu.addClass('show');
    subsubmenu.removeClass('hidden');
    arrow.addClass('up');
    arrow.removeClass('down');
  }

  window.addEventListener('resize', hideProductSubmenuAfterResize);
});
